module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av362-ad05ac7e32f72f41257d68a27f5aa5cf.jpg";